import { createContext, useContext } from 'react';

import { UsePreviewSessionManagerReturn } from './hooks/usePreviewSessionManager';

/**
 * Type alias for the Preview Session context value.
 * Provides session state and methods for managing active preview sessions.
 */
export type PreviewSessionContextValue = UsePreviewSessionManagerReturn;

/**
 * React Context for managing preview session state.
 * Tracks active preview sessions across multiple devices and supports
 * multi-device same-customer sharing and auto-expiry.
 */
export const PreviewSessionContext = createContext<PreviewSessionContextValue | undefined>(
  undefined,
);

/**
 * Custom hook to access the Preview Session context.
 * @throws {Error} If used outside of a PreviewSessionProvider
 * @returns {PreviewSessionContextValue} The session context value
 */
export const usePreviewSession = (): PreviewSessionContextValue => {
  const context = useContext(PreviewSessionContext);
  if (!context) {
    throw new Error('usePreviewSession must be used within a PreviewSessionProvider');
  }
  return context;
};
